/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { textPostTextBase64Encode } from "../../funcs/textPostTextBase64Encode.js";
import { PostTextBase64EncodeRequest$zodSchema } from "../../models/posttextbase64encodeop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: PostTextBase64EncodeRequest$zodSchema,
};

export const tool$textPostTextBase64Encode: ToolDefinition<typeof args> = {
  name: "text-post-text-base64-encode",
  description: `Base64 编码

这是一个简单实用的 Base64 编码工具。

## 功能概述
你提供一段原始文本，我们帮你转换成 Base64 编码的字符串。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await textPostTextBase64Encode(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
